export default "__VITE_ASSET__Cvwq7spf__"